import React from 'react'

class Overlay extends React.Component {
  render () {
    return (
      <div style={styles.overlay} />
    )
  }
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: -60,
    backgroundColor: '#b3d2fa',
    zIndex: -1,
  }
}

export default Overlay



/** WEBPACK FOOTER **
 ** ./src/components/Overlay.js
 **/